import { RegisterInput } from "@/types/Auth";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import Button from "src/components/atoms/Button";
import PasswordField from "src/components/atoms/Form/PasswordField";
import TextField from "src/components/atoms/Form/TextField";
import { useAuth } from "src/contexts/AuthContext";
import * as yup from "yup";

const schema = yup.object().shape({
  firstName: yup.string().required("Ingresa tu nombre"),
  lastName: yup.string().required("Ingresa tu apellido"),
  profileUrl: yup
    .string()
    .min(0)
    .max(100, "Máximo 100 caracteres")
    .matches(
      /^[0-9A-Za-z_-]{1,100}$/,
      "Solo se permiten caracteres alfanuméricos, guiones y guiones bajos"
    )
    .required("URL de perfil es requerida"),
  email: yup
    .string()
    .email("Correo electrónico inválido")
    .required("Correo electrónico es requerido"),
  password: yup
    .string()
    .required("Contraseña es requerida")
    .matches(
      // reges with minum 8 characters, one uppercase, one lowercase and one number
      /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+`\-=\[\]\\;',./{}|:"<>?~]{8,}$/,
      "La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula y un número"
    ),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref("password"), undefined], "Contraseñas no coinciden"),
});

interface RegisterFormProps {
  onRegister?: () => void;
}

const RegisterForm: React.FC<RegisterFormProps> = ({ onRegister }) => {
  const { register: registerUser, registerMutation } = useAuth();
  const { isLoading, isError, error } = registerMutation;
  const resolver = yupResolver(schema);
  const methods = useForm<RegisterInput>({
    resolver,
  });

  const { register, handleSubmit, watch } = methods;

  const watchedProfileUrl = watch("profileUrl");

  const onSubmit = handleSubmit((data: RegisterInput) => {
    registerUser(data);
    if (onRegister) onRegister();
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={onSubmit}>
        <div className="space-y-4">
          <TextField
            {...register("firstName")}
            name="firstName"
            id="firstName"
            label="Nombre"
          />
          <TextField
            {...register("lastName")}
            name="lastName"
            id="lastName"
            label="Apellido"
          />
          <TextField
            {...register("email")}
            name="email"
            id="email"
            label="Email"
            placeholder="codealo@example.com"
          />
          <TextField
            {...register("profileUrl")}
            name="profileUrl"
            id="profileUrl"
            label="URL de Perfil"
            placeholder=""
            description={
              <span>
                Tu url de perfil será{" "}
                <strong>codealo.com/perfiles/{watchedProfileUrl || ""}</strong>
              </span>
            }
          />
          <PasswordField
            {...register("password")}
            name="password"
            id="password"
            label="Contraseña"
            placeholder=""
            type="password"
          />
          <PasswordField
            {...register("passwordConfirmation")}
            name="passwordConfirmation"
            id="passwordConfirmation"
            label="Confrimar Contraseña"
            placeholder=""
            type="password"
          />
          <div className="pt-4">
            <Button
              onClick={onSubmit}
              variant={"solid"}
              color={"primary"}
              size={"lg"}
              type={"button"}
              block={true}
              loading={isLoading}
            >
              Crear Cuenta
            </Button>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default RegisterForm;
